export interface CustomMeta {
  name?: string;
  property?: string;
  content: string;
}

export interface HeadContentData {
  title: string;
  description: string;
  keywords: string;
  ogTitle: string;
  ogDescription: string;
  ogImage: string;
  ogType: string;
  twitterCard: string;
  twitterTitle: string;
  twitterDescription: string;
  twitterImage: string;
  canonicalUrl: string;
  favicon: string;
  appleTouchIcon: string;
  customMeta: CustomMeta[];
  structuredData: Record<string, any>[];
}

export interface HeadContentEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  initialData?: any;
  isLoading?: boolean;
  /** Site ID for media library access */
  siteId?: string;
  /** Site-wide Social Image URL. Used when the page OG field is blank. */
  siteOgImage?: string;
}

export const DEFAULT_FORM_DATA: HeadContentData = {
  title: '',
  description: '',
  keywords: '',
  ogTitle: '',
  ogDescription: '',
  ogImage: '',
  ogType: 'website',
  twitterCard: 'summary_large_image',
  twitterTitle: '',
  twitterDescription: '',
  twitterImage: '',
  canonicalUrl: '',
  favicon: '',
  appleTouchIcon: '',
  customMeta: [],
  structuredData: [],
};

export const TABS = [
  { id: 'basic', label: 'Basic SEO' },
  { id: 'social', label: 'Social Media' },
  { id: 'advanced', label: 'Advanced' },
];
